














































import {DrawerType} from '../mdc-drawer/'
import { Component, Prop, Vue } from 'vue-property-decorator'
import {  DrawerBreakPoints } from '@/components/mdc-drawer/drawer-break-points'
@Component({})
export default class MdcApp extends Vue{
  @Prop({default:'modal'}) drawerType!:DrawerType | 'auto'
  get currentDrawerType():DrawerType{
    if(this.drawerType === 'auto'){
      return this.breakPoints.drawerType
    }
    return this.drawerType
  }

  breakPoints:DrawerBreakPoints  = new DrawerBreakPoints()

  constructor(){
    super()
  }
  mounted(){
    this.breakPoints.init()
  }
  beforeDestroy(){
    this.breakPoints.destroy()
  }
}
